<div class="layout-switcher-container">
  <button mat-icon-button
          class="layout-menu-trigger"
          [matTooltip]="isMobileView ? 'Toggle navigation panel' : 'Single tree view'"
          (click)="isMobileView ? selectLayout('toggle_mobile_nav') : selectLayout('single_tree')">
    <mat-icon>account_tree</mat-icon>
  </button>

  <!-- Search button - only show when hideSearch is false -->
  <button *ngIf="!hideSearch"
          mat-icon-button
          class="search-button"
          (click)="toggleSearch()"
          matTooltip="Search subjects">
    <mat-icon>search</mat-icon>
  </button>

  <!-- Search input - only show when showSearch is true and hideSearch is false -->
  <div class="search-container" *ngIf="showSearch && !hideSearch">
    <input #searchInput type="text" class="search-input"
           placeholder="Search in English or Hindi..."
           [(ngModel)]="searchTerm"
           (keyup)="onSearchKeyUp($event)"
           (keyup.enter)="performSearch()"
           matTooltip="Search in both English and Hindi text">
    <button mat-icon-button class="clear-search" *ngIf="searchTerm" (click)="clearSearch()" matTooltip="Clear search">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- These buttons should be outside the search container but only visible when search is shown and hideSearch is false -->
  <ng-container *ngIf="showSearch && !hideSearch">
    <button mat-icon-button class="filter-toggle"
            [class.active-filter]="filterMode"
            (click)="toggleFilterMode()"
            [matTooltip]="filterMode ? 'Show all nodes' : 'Show only matching nodes'">
      <mat-icon>filter_list</mat-icon>
    </button>
    <button mat-icon-button
            class="search-now-button"
            (click)="performSearch()"
            matTooltip="Search now"
            color="primary">
      <mat-icon>search</mat-icon>
    </button>
  </ng-container>
</div>
